import strings from "./EvaluationAssistanceSummary.strings";
import { useStrings } from "features/i18n/useStrings";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "app/hooks";
import { selectQuestionsWithAssistance } from "features/qualityForm/qualityFormSlice";
import { selectIsQuestionHavingValidAssistedConditions } from "features/qualityForm/qualityFormValidations";
import {
    EvaluationSidePanelSummary,
    EvaluationSidePanelSummaryProps,
} from "components/EvaluationSidePanelSummary";

export function EvaluationAssistanceSummary() {
    const t = useStrings(strings);
    const {
        totalQuestions,
        totalQuestionsWithAssistance,
        questionsWithInvalidAssistanceConfig,
    } = useAppSelector((state) => {
        const totalQuestions = Object.keys(
            state.qualityForm.data.questions ?? {}
        ).length;
        const questionIdsWithAssistance = selectQuestionsWithAssistance(state);
        const totalQuestionsWithAssistance =
            questionIdsWithAssistance?.length ?? 0;
        const questionsWithInvalidAssistanceConfig =
            questionIdsWithAssistance.filter(
                (id) =>
                    !selectIsQuestionHavingValidAssistedConditions(state, id)
            )?.length ?? 0;
        return {
            totalQuestions,
            totalQuestionsWithAssistance,
            questionsWithInvalidAssistanceConfig,
        };
    }, shallowEqual);

    const evaluationSidePanelSummaryProps: EvaluationSidePanelSummaryProps = {
        iconName: "evaluationAssistance",
        assistanceIcon: t.labels.assistanceIcon,
        heading: t.labels.heading,
        summary: t.summary({
            questionsConfiguredWithAssistance: totalQuestionsWithAssistance,
            totalQuestionCount: totalQuestions,
            entity:
                totalQuestions === 1 ? t.labels.question : t.labels.questions,
        }),
        hasError: questionsWithInvalidAssistanceConfig > 0,
        errorMessage: t.invalidConditions({
            invalidConditions: questionsWithInvalidAssistanceConfig,
            entity:
                questionsWithInvalidAssistanceConfig === 1
                    ? t.labels.condition
                    : t.labels.conditions,
        }),
    };
    return (
        <div data-testid="evaluation-assistance-summary">
            <EvaluationSidePanelSummary {...evaluationSidePanelSummaryProps} />
        </div>
    );
}
